import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=cbdb381c&scoped=true&"
import script from "./ContentComponent.vue?vue&type=script&lang=js&"
export * from "./ContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb381c",
  null
  
)

export default component.exports